// extracted by mini-css-extract-plugin
export default {"container":"simon-center-button_container__136pf","shadow":"simon-center-button_shadow__2O2U6","top":"simon-center-button_top__3lF4j","down":"simon-center-button_down__1hFSd"};